// Contratti standard e contratti eventi: stesso wizard e stessa lista
// (pages/ContrattiPage.jsx), ciascuno col suo catalogo servizi. Il campo
// `ambito` di servizi e contratti è descritto in backend/ambiti.py; assente
// vale "standard", come lì.
export const AMBITI_CONTRATTO = {
  standard: {
    percorso: "/contratti",
    titolo: "Contratti",
    catalogo: "Catalogo Servizi",
  },
  eventi: {
    percorso: "/contratti-eventi",
    titolo: "Contratti eventi",
    catalogo: "Catalogo Servizi Eventi",
  },
};

export function ambitoDi(doc) {
  return doc?.ambito === "eventi" ? "eventi" : "standard";
}

// Pagina che apre un contratto: un contratto eventi aperto da Contratti non
// troverebbe i suoi servizi nel catalogo caricato.
export function percorsoContratto(doc) {
  return AMBITI_CONTRATTO[ambitoDi(doc)].percorso;
}
